import React from 'react';

export default function MatchSummaryBox({ mode, settings }) {
  if (!settings) return null;

  let winConditionTitle = 'Classic Match';
  let winConditionDesc = 'The game continues until a team reaches +6 points to win, or drops to -6 points and loses.';

  if (settings.sprint_rounds > 0) {
    winConditionTitle = 'Sprint Series';
    winConditionDesc = `Fast-paced match! The game ends strictly after ${settings.sprint_rounds} rounds. The team with the most points wins. (Sudden Death on tie).`;
  } else if (settings.escalation_timer) {
    winConditionTitle = 'Escalation Protocol';
    winConditionDesc = 'Timer is active! All points won or lost multiply by 2x after 30 minutes, and by 4x after 60 minutes. High stakes!';
  }

  const modifiers = [];
  if (settings.deal_mode === 'phase') {
    modifiers.push({ icon: '🃏', title: 'Phase Deal', desc: 'Cards are dealt in two phases (4 first, then the rest).' });
  }
  if (settings.allow_doubling) {
    modifiers.push({ icon: '⚔️', title: 'Double / Redouble', desc: 'Defenders can double the stakes if they feel confident.' });
  }
  if (settings.royal_pair) {
    modifiers.push({ icon: '👑', title: 'Royal Pair', desc: 'Holding the King & Queen of Trump alters the contract target by 4.' });
  }

  return (
    <div className="glass-panel" style={{ marginTop: '24px', padding: '24px', textAlign: 'left' }}>
      <h3 style={{ margin: '0 0 16px 0', color: '#facc15', fontSize: '1rem', textTransform: 'uppercase', letterSpacing: '1px' }}>
        Current Match Rules
      </h3>
      
      <div style={{ marginBottom: '16px' }}>
        <strong style={{ color: '#d4af37', fontSize: '1.1rem', display: 'block', marginBottom: '6px' }}>
          {winConditionTitle}
        </strong>
        <span style={{ fontSize: '0.85rem', color: '#94a3b8', lineHeight: '1.4' }}>
          {winConditionDesc}
        </span>
      </div>

      {modifiers.length > 0 && (
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '16px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <strong style={{ color: '#94a3b8', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '1px' }}>Active Modifiers</strong>
          {modifiers.map((mod, i) => (
            <div key={i} style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
              <span style={{ fontSize: '1.2rem', lineHeight: '1' }}>{mod.icon}</span>
              <div>
                <div style={{ fontSize: '0.9rem', color: '#f1f5f9', fontWeight: 'bold' }}>{mod.title}</div>
                <div style={{ fontSize: '0.8rem', color: '#64748b', lineHeight: '1.3' }}>{mod.desc}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
